import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let Ventures = class Ventures extends VuexModule {
    constructor() {
        super(...arguments);
        this.ventures = [];
        this.cachedVersion = 0;
    }
    async fetchVentures() {
        const { data: ventures, cachedVersion } = await fetchFromCache(this, 'ventures', 'starshipVenture');
        return { ventures, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['ventures', 'cachedVersion'] })
], Ventures.prototype, "fetchVentures", null);
Ventures = __decorate([
    Module({ namespaced: true, name: 'ventures' })
], Ventures);
export default Ventures;
